import { useEffect, useRef } from 'react'
import ButtonComponent from '../../stories/atoms/button'
import {
  buttonTypeOptions,
  buttonVariantOptions
} from '../../stories/atoms/button/constants'
import {
  ChevronRightSmall,
  ChevronLeftSmall
} from '../../stories/atoms/icons/essentials'
import {
  PaginationCount,
  ProjectPaginationContainer
} from '../styled-components'
import { useHistory } from 'react-router-dom'
import { FormattedMessage } from 'react-intl'
import PropTypes from 'prop-types'

const ProjectInfoPanelPagination = ({
  projectDetails,
  projectTree,
  isLoading,
  fetchNextPage,
  hasNextPage,
  isFetchingNextPage
}) => {
  const history = useHistory()
  const pendingNextNavigation = useRef(false)
  const currentProjectId = projectDetails?.id

  const projectIdList = projectTree?.map((item) => item.id) ?? []

  const currentProjectIndex = projectIdList.indexOf(currentProjectId)

  const nextProject = projectIdList[currentProjectIndex + 1]
  const previousProject = projectIdList[currentProjectIndex - 1]

  useEffect(() => {
    if (!pendingNextNavigation.current || isFetchingNextPage) return
    const newNextProject = projectIdList[currentProjectIndex + 1]
    if (newNextProject) {
      pendingNextNavigation.current = false
      history.push(`/project/info/${newNextProject}`)
    }
  }, [projectIdList, currentProjectIndex, isFetchingNextPage])

  const handleNavigateBetweenProjects = (projectId) => {
    if (projectId) {
      history.push(`/project/info/${projectId}`)
    }
  }

  const handleNext = () => {
    if (nextProject) {
      handleNavigateBetweenProjects(nextProject)
    } else if (hasNextPage && !isFetchingNextPage) {
      pendingNextNavigation.current = true
      fetchNextPage()
    }
  }

  const disableNextButton = !nextProject && (!hasNextPage || isFetchingNextPage)
  const disablePreviousButton = !previousProject

  if (currentProjectIndex === -1) return null

  return (
    <ProjectPaginationContainer>
      <ButtonComponent
        buttonType={buttonTypeOptions['ICON-ONLY']}
        variant={buttonVariantOptions.GHOST}
        onClick={() => handleNavigateBetweenProjects(previousProject)}
        disabled={disablePreviousButton}
      >
        <ChevronLeftSmall />
      </ButtonComponent>
      <PaginationCount>
        <FormattedMessage
          id="pagination_count"
          values={{
            current: isLoading ? '-' : currentProjectIndex + 1,
            total: isLoading ? '-' : projectIdList.length
          }}
        />
      </PaginationCount>
      <ButtonComponent
        buttonType={buttonTypeOptions['ICON-ONLY']}
        variant={buttonVariantOptions.GHOST}
        onClick={handleNext}
        disabled={disableNextButton}
      >
        <ChevronRightSmall />
      </ButtonComponent>
    </ProjectPaginationContainer>
  )
}

ProjectInfoPanelPagination.propTypes = {
  projectDetails: PropTypes.object,
  projectTree: PropTypes.array,
  isLoading: PropTypes.bool,
  fetchNextPage: PropTypes.func,
  hasNextPage: PropTypes.bool,
  isFetchingNextPage: PropTypes.bool
}

export default ProjectInfoPanelPagination
